export const categories = [
  {
    key: 'music',
    name: '音乐',
    icon: 'ri-music-2-line',
    desc: '翻唱、原创、现场演奏，把好听的旋律一次听够。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20sunset%20stage%20with%20acoustic%20guitar%20and%20microphone%2C%20soft%20golden%20light%2C%20clean%20minimal%20background%2C%20editorial%20music%20photography%20with%20vibrant%20red%20accents&width=600&height=600&seq=cat-music-01&orientation=squarish',
  },
  {
    key: 'comedy',
    name: '搞笑',
    icon: 'ri-emotion-happy-line',
    desc: '沙雕日常、整蛊名场面，每天笑一笑压力全走掉。',
    cover: 'https://readdy.ai/api/search-image?query=Playful%20bright%20studio%20scene%20with%20colorful%20props%20and%20confetti%2C%20fun%20cheerful%20mood%2C%20clean%20minimal%20background%2C%20commercial%20lifestyle%20photography%2C%20orange%20accents%2C%20high%20detail&width=600&height=600&seq=cat-comedy-01&orientation=squarish',
  },
  {
    key: 'life',
    name: '生活',
    icon: 'ri-home-5-line',
    desc: '租房改造、收纳整理、治愈日常，把日子过成想要的样子。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20minimal%20sunlit%20apartment%20interior%20with%20plants%20and%20warm%20linen%20textiles%2C%20soft%20natural%20light%2C%20clean%20neutral%20background%2C%20lifestyle%20editorial%20photography%2C%20high%20detail&width=600&height=600&seq=cat-life-01&orientation=squarish',
  },
  {
    key: 'food',
    name: '美食',
    icon: 'ri-restaurant-2-line',
    desc: '家常快手菜到深夜食堂，跟着做就能香到邻居敲门。',
    cover: 'https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20hot%20noodles%20with%20fresh%20herbs%20on%20a%20rustic%20wooden%20table%2C%20warm%20moody%20lighting%2C%20clean%20simple%20background%2C%20appetizing%20food%20photography%20with%20rich%20red%20tones%2C%20high%20detail&width=600&height=600&seq=cat-food-01&orientation=squarish',
  },
  {
    key: 'dance',
    name: '舞蹈',
    icon: 'ri-footprint-line',
    desc: '街舞 battle、国风水袖、K-pop 翻跳，节拍一响就停不下来。',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20dance%20studio%20with%20mirror%20wall%20and%20warm%20spotlight%2C%20motion%20energy%2C%20minimal%20clean%20background%2C%20editorial%20performance%20photography%2C%20vivid%20red%20and%20orange%20accents%2C%20high%20detail&width=600&height=600&seq=cat-dance-01&orientation=squarish',
  },
  {
    key: 'travel',
    name: '旅行',
    icon: 'ri-flight-takeoff-line',
    desc: '小众路线、海边浮潜、城市暴走，带你云游世界每个角落。',
    cover: 'https://readdy.ai/api/search-image?query=Serene%20mountain%20lake%20at%20golden%20hour%20with%20distant%20snow%20peaks%2C%20soft%20haze%2C%20minimal%20wide%20landscape%2C%20travel%20editorial%20photography%2C%20warm%20orange%20sky%2C%20high%20detail&width=600&height=600&seq=cat-travel-01&orientation=squarish',
  },
  {
    key: 'pets',
    name: '萌宠',
    icon: 'ri-bear-smile-line',
    desc: '金毛看海、布偶睡姿、仓鼠囤粮，毛孩子的快乐日常。',
    cover: 'https://readdy.ai/api/search-image?query=Adorable%20golden%20retriever%20puppy%20looking%20at%20camera%20on%20a%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20clean%20simple%20backdrop%2C%20cute%20pet%20photography%2C%20high%20detail&width=600&height=600&seq=cat-pets-01&orientation=squarish',
  },
  {
    key: 'sports',
    name: '运动',
    icon: 'ri-basketball-line',
    desc: '球场绝杀、晨跑打卡、徒手健身，一起练出好状态。',
    cover: 'https://readdy.ai/api/search-image?query=Outdoor%20basketball%20court%20at%20sunset%20with%20a%20ball%20in%20mid%20air%2C%20dynamic%20warm%20lighting%2C%20clean%20minimal%20background%2C%20sports%20action%20photography%2C%20orange%20sky%2C%20high%20detail&width=600&height=600&seq=cat-sports-01&orientation=squarish',
  },
];